import { useState, useEffect } from "react";
import { FiX } from "react-icons/fi";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookie_consent");
    if (!accepted) {
      // Small delay so it doesn't flash on load
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookie_consent", "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] p-4 animate-slide-up">
      <div className="max-w-4xl mx-auto bg-dark-700 border border-dark-400 rounded-2xl shadow-2xl p-5 md:p-6">
        <div className="flex items-start gap-4">
          {/* Cookie Icon */}
          <div className="hidden sm:flex shrink-0 w-10 h-10 bg-primary/10 rounded-full items-center justify-center text-lg">
            🍪
          </div>

          <div className="flex-1">
            <h3 className="text-sm font-semibold text-white mb-1">
              We use cookies
            </h3>
            <p className="text-xs text-gray-400 leading-relaxed mb-4">
              We use cookies and similar technologies to improve your experience on our site, analyze traffic, and personalize content. By clicking "Accept All", you consent to the use of cookies.{" "}
              <a href="/cookies-policy" className="text-primary hover:underline">
                Learn more
              </a>
            </p>

            <div className="flex items-center gap-3">
              <button
                onClick={handleAccept}
                className="btn-play-gradient btn-play-gradient-xs"
              >
                Accept All
              </button>
              <button
                onClick={handleDecline}
                className="px-5 py-2 text-xs font-semibold text-gray-300 border border-dark-400 rounded-full hover:border-white/30 hover:text-white transition-all uppercase tracking-wide"
              >
                Decline
              </button>
            </div>
          </div>

          {/* Close */}
          <button
            onClick={handleDecline}
            className="shrink-0 p-1.5 text-gray-500 hover:text-white transition-colors"
            aria-label="Close cookie banner"
          >
            <FiX size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
